var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTitan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.108 23.981a8.1 8.1 0 0 0 7.982-6.72 42.79 42.79 0 0 1-2.008 1.15 3.372 3.372 0 0 1-4.87 2.288 46.897 46.897 0 0 1-5.63 1.9 8.06 8.06 0 0 0 4.526 1.383zm-.629-5.59c-2.217.864-4.32 1.494-6.172 1.892a8.098 8.098 0 1 1 14.682-6.268 35.994 35.994 0 0 1-2.58 1.588 3.37 3.37 0 0 0-5.93 2.788zm11.51-2.507c0-.198-.004-.395-.015-.59 2.949-2.266 4.51-4.462 3.891-5.912-.627-1.473-3.367-1.859-7.134-1.263A10.848 10.848 0 0 0 16.108 5C10.098 5 5.225 9.872 5.225 15.883v.097C2.147 18.3.502 20.562 1.134 22.045c.622 1.46 3.318 1.852 7.033 1.28a10.853 10.853 0 0 0 7.94 3.44c6.011 0 10.884-4.872 10.884-10.882zm-.637-3.681a10.84 10.84 0 0 0-.682-1.519c.9-.074 1.607-.06 2.127.005-.31.414-.781.926-1.444 1.514zm-22.15 8.536c.322-.43.818-.967 1.522-1.583.173.548.388 1.077.64 1.584-.916.077-1.635.063-2.162-.002zM28.226 9.95s0 .01-.007.028a.1.1 0 0 1 .006-.028zM3.374 20.536a.1.1 0 0 1 .024.014.088.088 0 0 1-.024-.014zm.4.94s0-.01.007-.028a.1.1 0 0 1-.006.027zm24.828-10.6a.09.09 0 0 1 .024.013s-.01-.004-.024-.014zm-7.987 6.84a1.832 1.832 0 1 1-3.664 0 1.832 1.832 0 0 1 3.665 0z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitan);
export default __webpack_public_path__ + "static/media/TITAN.32388feccb090fb6ef96f900c1e966b7.svg";
export { ForwardRef as ReactComponent };